<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="true"
      :searchable="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'slug'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      let obj = this.options.filter((o) => o.value == this.value)[0];
      this.$emit('onChange', this.value, obj);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;

      let endpoint = 'api/product_type';

      if (this.slug) {
        endpoint += `?slug=${this.slug}`;
      }

      this.$api
        .get(endpoint)
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name, slug: b.slug };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
